import React, { createContext, useContext } from "react";

const MenuContext = createContext();

export function useMenu() {
  return useContext(MenuContext);
}

export function MenuProvider({ value, children }) {
  return (
    <MenuContext.Provider value={value}>
      {children}
    </MenuContext.Provider>
  );
}